function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  className: styles["a"] || "a",
  d: "M8 16c0-.828.447-2 1-2v-2H7V5l.8-5H4.2L5 5v7H3v2c.553 0 1 1.172 1 2 0 .828-.447 2-1 2v4c0 1 1 2 3 2s3-1 3-2v-4c-.553 0-1-1.172-1-2M20.9 5c0 1.992-.9 4-2.9 5v12c0 1-1 2-2 2s-2-1-2-2V10c-2-1-2.9-3.008-2.9-5A4.895 4.895 0 0114 .535V5l2 2 2-2V.535A4.895 4.895 0 0120.9 5"
}));